@use '@design/design-tokens/typography/typography' as *;

@layer chart {
  .styledModal {
    [data-modal-container] {
      width: 504px;
      padding: 0;
    }
  }

  .container {
    padding: 12px 20px;
  }

  .row {
    display: flex;
    flex-grow: 1;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;

    &:not(:last-child) {
      border-bottom: 1px solid var(--border-soft);
    }

    & span {
      @include typography-v2-body-base;
    }
  }
}
